import React from 'react';
import Icons from './Icons';

const LawyerMembership = () => {
  return (
    <section className="membership-section" id="soy-abogado">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Haz crecer tu práctica legal con GesOps</h2>
          <p className="section-description">
            En GesOps LLC te conectamos con miles de personas que buscan abogados en todo Estados Unidos.
          </p>
          <p className="section-description">
            Al formar parte de nuestro directorio, tu firma obtiene mayor visibilidad, credibilidad y presencia digital, dentro de una plataforma que promueve la confianza y la transparencia profesional.
          </p>
        </div>


        <div className="plans-container single-plan">
          <div className="plan-card premium-plan featured">
            <div className="plan-badge">Plan Recomendado</div>
            <div className="plan-header">
              <div className="plan-icon"><Icons.Star /></div>
              <h3 className="plan-title">Plan Premium</h3>
              <div className="plan-price">
                <span className="price-amount">$250</span>
                <span className="price-period">/mes</span>
              </div>
            </div>
            
            <div className="plan-features">
              <h4 className="features-title">Incluye:</h4>
              <ul className="features-list">
                <li className="feature-item">
                  <span className="feature-icon"><Icons.FileText /></span>
                  Perfil completo con biografía extendida
                </li>
                <li className="feature-item">
                  <span className="feature-icon"><Icons.Target /></span>
                  Integración con CRM propio
                </li>
                <li className="feature-item">
                  <span className="feature-icon"><Icons.TrendingUp /></span>
                  Presencia destacada en marketing
                </li>
                <li className="feature-item">
                  <span className="feature-icon"><Icons.Users /></span>
                  Soporte prioritario
                </li>
              </ul>
            </div>
            
            <div className="premium-note">
              <p className="note-text">
                <strong>Nota:</strong> Abogados Premium que contraten Back Office tendrán acceso al CRM propio de GesOps.
              </p>
            </div>
            
            <div className="plan-action">
              <button className="btn btn-primary plan-btn">Adquirir Plan Premium</button>
            </div>
          </div>
        </div>

        <div className="membership-cta">
          <div className="cta-content">
            <h3 className="cta-title">¿Necesitas más información?</h3>
            <div className="cta-buttons">
              <button className="btn btn-secondary">Solicitar información</button>
              <button className="btn btn-primary">Contactar ahora</button>
            </div>
          </div>
        </div>

        <div className="membership-disclaimer">
          <div className="disclaimer-box">
            <span className="disclaimer-icon"><Icons.Scale /></span>
            <div className="disclaimer-content">
              <p>
                <strong>Aviso importante:</strong> Los abogados mantienen independencia total en su práctica. 
                GesOps LLC solo proporciona visibilidad digital y servicios administrativos opcionales. 
                No compartimos honorarios ni participamos en la relación abogado-cliente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LawyerMembership;
